var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TWorkPackage',{key:`workpackage${_vm.workpackage.id}`,attrs:{"workpackage_count":_vm.waggon.tworkpackages.length,"workpackage":_vm.workpackage,"easter_egg":_vm.easter_egg,"color":_vm.getStatisticSettings.filter &&
          (
          (_vm.getStatisticSettings.colors.length !== 0 &&
          !_vm.getStatisticSettings.colors.includes(_vm.workpackage.color)) ||
          (_vm.getStatisticSettings.icons.length !== 0 &&
          !_vm.getStatisticSettings.icons.includes(_vm.workpackage.icon)) ||
          (_vm.getStatisticSettings.status.length !== 0 &&
          !_vm.getStatisticSettings.status.includes(_vm.workpackage.status)) ||
          (_vm.getStatisticSettings.trains.length !== 0 &&
          !_vm.getStatisticSettings.trains.includes(_vm.train.id))

        ) ||
        (_vm.isShowOwnWps &&
        _vm.getOwnTWorkPackages(_vm.project_id).length !== 0 &&
        !_vm.getOwnTWorkPackages(_vm.project_id).includes(_vm.workpackage.id))
        ?
        'grey darken-2':false},nativeOn:{"click":function($event){return _vm.handleTWorkpackageClick(
    _vm.train,
    _vm.waggon,
    _vm.workpackage,
    _vm.train.id,
    _vm.taktarea.id,
    _vm.waggon.id,
    _vm.workpackage.id,
    $event
    )}},scopedSlots:_vm._u([{key:"workpackage",fn:function(workpackageslot){return [_c('transition',{attrs:{"name":"zoom"}},[(!(_vm.hover_waggon && _vm.isEditMode) &&
              workpackageslot.workpackage.status &&
              (workpackageslot.workpackage.status !== 'none' || workpackageslot.workpackage.stop_status !== 'none') &&
              _vm.isShowStatusBadges &&
              _vm.workpackage.status !== 'stop'
              )?_c('StandardBadge',{key:`workpackagebadge${_vm.workpackage.id}`,staticClass:"cursor-pointer",attrs:{"icon":_vm.workpackage.stop_status !== 'none'?(_vm.workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):_vm.getStatusArray.find(status => status.name === workpackageslot.workpackage.status).icon,"color":"white","content_color":workpackageslot.workpackage.stop_status !== 'none' ? 'red':'black'},nativeOn:{"click":function($event){_vm.$route.name === 'ProjectTaktPlan'?_vm.$emit('openWaggonInfo', $event):''}}}):_vm._e()],1),(workpackageslot.workpackage.status &&
            workpackageslot.workpackage.status !== 'none' &&
            !_vm.isShowStatusBadges)?_c('StandardBadgeMini'):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }